"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "Do you charge for quotes?",
  answer: "No, we provide free, no-obligation quotes for all electrical projects. Our experts will assess your requirements and provide a transparent breakdown of costs before any work begins."
}, {
  question: "Are you fully insured and certified?",
  answer: "Absolutely. AD Electrical is fully insured and all our technicians are NICEIC certified. We adhere to the latest BS 7671 wiring regulations to ensure the highest safety standards for your property."
}, {
  question: "Do you handle both domestic and commercial work?",
  answer: "Yes, we have dedicated teams for both sectors. Whether it's a simple fuse board upgrade in a home or a complex full-scale rewiring for a commercial warehouse, we have the expertise to deliver."
}];
export default function FaqSection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222902" id="common-questions" className="bg-background text-foreground w-full py-16 md:py-24">
      <div ref={ref} className={`mx-auto w-full max-w-[800px] px-4 sm:px-6 transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <div className="mb-12 text-center">
          <h2 className="font-default text-foreground text-3xl font-bold tracking-tight md:text-4xl">
            Common Questions
          </h2>
          <p className="font-default text-muted-foreground mt-4 text-base md:text-lg">
            Find answers to common queries about our electrical services, safety standards, and emergency response times.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem data-index={i} key={i} value={`item-${i}`} className="border-b border-border">
              <AccordionTrigger className="font-default text-foreground hover:text-ring text-left text-base font-bold sm:text-lg transition-colors">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="font-sans text-muted-foreground text-sm leading-relaxed sm:text-base">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}